import { render } from "./Album.vue?vue&type=template&id=78631962"
import script from "./Album.vue?vue&type=script&lang=js"
export * from "./Album.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__